export const CHOOSE_MATERIAL = ".pplr-wrapper.pplr-choose-material";
export const DROP_ITEM = ".pplr-choose-material .pplr-drop-item";
export const DESCRIPTION_TEXT = ".description-text > li";
